import React, { createContext, PropsWithChildren, useCallback, useState } from 'react';

interface StaleSessionContextValue {
  isSessionStale: boolean;
  markSessionStale: () => void;
}

export const StaleSessionContext = createContext<StaleSessionContextValue>({
  isSessionStale: false,
  // Default for consumers rendered outside StaleSessionProvider; the provider supplies the real handler.
  markSessionStale: () => {},
});

export const StaleSessionProvider = ({ children }: PropsWithChildren) => {
  const [isSessionStale, setIsSessionStale] = useState(false);
  const markSessionStale = useCallback(() => setIsSessionStale(true), []);

  return (
    <StaleSessionContext.Provider value={{ isSessionStale, markSessionStale }}>
      {children}
    </StaleSessionContext.Provider>
  );
};
